export const COMMON_FIELDS = ['frictionless', 'use_pdp', 'pdp_url', 'name'] as const;

export const FRICTIONLESS_PARAMS = ['variant_id', 'promo_code'] as const;
